import { useSelector } from './useSelector';
export var useFeatureFlagState = function (flag) {
    var featureFlagIsEnabled = useSelector(function (state) { var _a, _b; return ((_b = (_a = state.featureFlags) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.feature === flag; })) === null || _b === void 0 ? void 0 : _b.setting) === 'ENABLED'; });
    return { enabled: featureFlagIsEnabled };
};
//# sourceMappingURL=useIsFeatureFlagEnabled.js.map